import React, { useEffect, useMemo } from "react";
import { useSelector , useDispatch} from "react-redux";
import { t } from "i18next";
import { useParams } from "react-router-dom";

import { BrandHeader } from "components";
import WithLoading from "components/Hoc/WithLoading";
import { NotFound, ErrorComponent } from "components";

import { useQueryParam } from "modules/dine-in/hooks";

import useEventTracker from "hooks/useEventTracker";
import { usePlatform } from "hooks";
import { useCustomHistory } from "hooks";

import { UTILS } from "utils";
import C from "Constants";
import { CustomButton } from "components/Button";
import { PriceRender } from "components/DisplayPrice";
import { OrderAction } from "store/actions";

const DineInPayLater = () => {
  usePlatform();
  const params = useParams();
  const dispatch = useDispatch();
  const router = useCustomHistory();
  const queryParam = useQueryParam();
  const { DomainType } = useSelector((state) => state?.AppReducer);
  const { notFound, brandMenuError } = useSelector((state) => state?.brand);
  const { selectedStore } = useSelector((state) => state?.store);
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);
  const { isLoading } = useSelector((state) => ({
    isLoading: state?.loader?.isLoading,
  }));
  const { ordered } = useSelector((state) => state?.order)

  const OrderTotalPrice = useMemo(() => {
    return ordered?.allOrders?.length > 0
      ? UTILS.roundToTwoDecimals(
          parseFloat(ordered?.ordersTotalPrice?.toFixed(2)) -
            parseFloat(ordered?.splitPayed)
        )
      : ordered?.splitPayed;
  }, [ordered]);

  useEventTracker({
    name: "HOME_DINE_IN",
    orderType: "DINE_IN",
    shouldLog: true,
  });

  const goToSettings = () => {
    if (params) {
      router(
        `/dine-in/auth/settings`,
        `/${params?.domainName}/dine-in/auth/settings`,
        DomainType,
        null,
        `?${queryParam}`
      );
    }
  };

  const goToMenu = () => {
    if (params) {
      router(
        `/dine-in`,
        `/${params?.domainName}/dine-in`,
        DomainType,
        null,
        `?${queryParam}`
      );
    }
  };

  const viewBasketPage = () => {
    if (params) {
      router(
        `/dine-in/checkout`,
        `/${params?.domainName}/dine-in/checkout`,
        DomainType,
        null,
        `?${queryParam}`
      );
    }
  };

  const goToLogin = () => {
    router(
      "/dine-in/auth/login",
      `/${params?.domainName}/dine-in/auth/login`,
      DomainType,
      null,
      `?${queryParam}`
    );
  };

  useEffect(() => {
    dispatch(OrderAction.setIsPayNow(false));
    dispatch(OrderAction. setOpenSplitBill(false));
    if (OrderTotalPrice <= 0) {
      goToMenu();
    }
  }, [OrderTotalPrice]);

  if (!isLoading && notFound) return <NotFound message={notFound} />;
  return (
    <WithLoading>
      <div className="store-page store-page-popup">
        <BrandHeader
          containerProps={{
            style: {
              height: "calc(100vh - 42%)",
              minHeight: "320px",
              maxHeight: "522px",
            },
          }}
          showImageAmbientEffect={false}
          imageProps={{
            style: {
              objectFit: "none",
            },
          }}
          navPanelContainerstylesProps={{
            style: {
              zIndex: "50",
              padding: "16px",
            },
            className: "z-50",
          }}
          hideUserNavPanel={false}
          userNavPanelProps={{
            orderTypes: [C.SERVICE_TYPE.DINE_IN],
            authClick: goToLogin,
            userClick: goToSettings,
          }}
        >
          {/* brand logo */}
          <div
            className="absolute w-full h-full flex justify-center items-center z-10"
            style={{
              height: "calc(100% - 100px)",
            }}
          >
            <img
              src={brandInfo?.setting?.brandLogoFirst}
              alt="brand logo"
              style={{
                height: "150px",
                width: "207px",
                backgroundImage: `url(${brandInfo?.setting?.brandLogoFirst})`,
                border: "12px white solid ",
                borderRadius: "12px",
              }}
            />
          </div>
          {/* welcome content */}
          <div
            className="absolute bottom-0 left-0 w-full h-full flex justify-end flex-col text-center"
            style={{
              maxHeight: "80%",
              background:
                "linear-gradient(183.41deg, rgba(255, 255, 255, 0) 6.07%, #FFFFFF 97.19%)",
              paddingBottom: "20px",
              zIndex: "1",
            }}
          >
            <h2 className="text-30x font-bold">
              {t(`Welcome!`)}{" "}
              <span dir="ltr">{t(selectedStore?.baseLanguage?.name)}</span>
            </h2>
            <p className="text-14x">
              {t("We Are Preparing Something Great For You!")}
            </p>
          </div>
        </BrandHeader>

        <div>{brandMenuError && <ErrorComponent error={brandMenuError} />}</div>

        <div className="p-6 mt-23 flex flex-col gap-4">
          {/* {ordered?.splitBills?.length > 0 ? null : ( */}
            <>
              <CustomButton
                type="button"
                onClick={goToMenu}
                style={{ marginTop: "auto" }}
                outline
              >
                {t("View Menu")}
              </CustomButton>
              <CustomButton
                type="button"
                onClick={()=>{
                  dispatch(OrderAction.setIsPayNow(true));
                  viewBasketPage();
                }}
                style={{ marginTop: "auto" }}
              >
                <div className="flex justify-center items-center gap-1">
                  {t("Pay Now")}
                  {" ( "}
                  <PriceRender
                    price={OrderTotalPrice}
                    className="text-16x leading-none"
                    currencySymbolClassName="cc"
                  />
                  {" )!"}
                </div>
              </CustomButton>
            </>
          {/* )} */}

          <CustomButton
            type="button"
            outline
            onClick={() => {
              dispatch(OrderAction.setOpenSplitBill(true));
              viewBasketPage();
            }}
            style={{ marginTop: "auto" }}
          >
            {t("Pay With Split Bill")}
          </CustomButton>
        </div>
      </div>
    </WithLoading>
  );
};

export default DineInPayLater;
